import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TCutbankOutState } from './cutbank-out-db.models';

export const selectCutbankOutStore = createFeatureSelector<TCutbankOutState>('CUTBANK_OUT_STORE');

export const getSubjects = createSelector(
  selectCutbankOutStore,
  (selectCutbankOutStore) => selectCutbankOutStore.subjects,
);

export const IsComponentBundleScanEnabled = createSelector(
  selectCutbankOutStore,
  (selectCutbankOutStore) => selectCutbankOutStore.isComponentBundleScanEnabled,
);

export const getTransactionLogInfo = createSelector(selectCutbankOutStore, (state) => state.transactionLogInfo);

export const getActivityLogInfo = createSelector(selectCutbankOutStore, (state) => state.activityLogInfo);
